import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { APPCONFIG } from '../../config';
import { MdDialog, MdDialogRef } from '@angular/material';
import { RequestService } from '../requests.service';
import { ErrorHandler } from '../../shared/services/error-handler.service';
import { HttpService } from '../../shared/services/http.service';
import { LayoutService } from '../../layout/layout.service';
import { SessionHandler } from '../../shared/services/session-handler.service';
import { CommonService } from '../../shared/services/common.service';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators
} from '@angular/forms';
import { dialogComponent } from '../../dialog/dialog.component';
import { termsDialogComponent } from '../../dialog/dialog.component';
import {
  itemClass,
  itemClassEdit,
  itemClassEditManual
} from '../return/itemClass';

@Component({
  selector: 'request-add',
  template: require('./confirm.component.html'),
  styles: [require('./confirm.component.scss')],
  providers: [HttpService, ErrorHandler, SessionHandler, RequestService]
})
export class RequestConfirmComponent {
  dialogRef;
  request: any;
  showField: any = [];
  serialNumber: any = [];
  itemError: boolean = false;
  userData: any;
  addressList: any;
  contactList: any;
  address: any;
  instructions: any;
  name: any;
  email: any;
  phone: any;
  isItem: boolean = false;
  item_list: any = [];
  manualListValid = [];
  serialNumberList: any = [];
  serialNumberInput: any = [];
  showEditSerial = [];
  tempSerialList = [];
  finalFormData: any;
  reasonList: any;
  reason: any;
  id: any;
  isAdmin: boolean = false;
  isOTD: boolean = false;
  isEndConsumner = false; 
  isEdit: boolean = false;
  showList: boolean = false;
  invoice_no_array: any = [];

duplicateReturnOrders: any[] = [];
showDuplicateDialog: boolean = false;
isDuplicateCheckInProgress: boolean = false;


  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpService,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private sessionHandler: SessionHandler,
    private dialog: MdDialog
  ) {
    this.userData = {};
    this.finalFormData = {};
    this.finalFormData.requestOrder = {};
    if (this.http.checkSession()) {
      this.route.params.subscribe(params => {
        this.id = +params['id'];
      });
      if (!isNaN(this.id)) {
        this.isEdit = true;
      }
      this.userData = JSON.parse(this.sessionHandler.getItem('loginData'));
      let requestData = this.commonService.getData();
      if (this.userData) {
        if (this.userData.role && this.userData.role.length > 0) {

          if (this.userData.role.includes('ADMIN')) {
            this.isAdmin = true;
          }
          if (this.userData.role.includes('OTD_APPROVER')) {
            this.isOTD = true;
          }
          if (this.userData.role.includes('END_CONSUMER')) {
            this.isEndConsumner = true; 
          }
          // ****Old role logic******
          // for (let u in this.userData.role) {
          //   if (this.userData.role[u] == 'ADMIN') {
          //     this.isAdmin = true;
          //   }
          //   if (this.userData.role[u] == 'OTD_APPROVER') {
          //     this.isOTD = true;
          //   }
          //   if (this.userData.role[u] == 'END_CONSUMER') {
          //     this.isEndConsumner = true; 
          //   }
          // }
        }
      }
      if (requestData) {
        this.finalFormData = JSON.parse(JSON.stringify(requestData));
        console.log('tradePartnerId=', this.finalFormData.tradePartnerId);
        console.log('tradeId=', this.finalFormData.tradeId);
        console.log(this.finalFormData);
        this.commonService.changeViewData(this.finalFormData);
        this.finalFormData.status = 'DRAFT';
        console.log(this.finalFormData,"**************************************************");
        console.log(this.finalFormData['status'],"**************************************************");
        if(this.finalFormData['status']=="REJECTED_FOR_INCOMPLETENESS"){
          this.finalFormData.status="REJECTED FOR INCOMPLETENESS"
        }
        if (
          this.finalFormData.returnOrder &&
          this.finalFormData.returnOrder.items
        ) {
          let returnOrder = [];
          for (let i in this.finalFormData.returnOrder.items) {
            returnOrder.push(this.finalFormData.returnOrder.items[i]['data']);
          }
          this.item_list = returnOrder;
          // this.setReturnData();
          if (
            this.finalFormData.returnItemUploadFlag == 0 ||
            this.finalFormData.returnItemUploadFlag == 1
          ) {
            this.item_list = Object.assign(
              [],
              this.finalFormData.returnOrder.items
            );
            this.finalFormData.returnOrder.invoiceNumber = '';
            this.setReturnDataManual();
          } else {
            this.item_list = returnOrder;
            this.setReturnData();
          }
        } else {
          this.router.navigateByUrl('/app/requests/create');
        }
      } else if (!isNaN(this.id)) {
        this.getRequestDataWithId();
      } else {
        this.router.navigateByUrl('/app/requests/create');
      }
    } else {
      this.http.showSessionError();
    }
  }

  ngOnInit() { }

  public getRequestDataWithId() {
    this.http
      .getRequest('returnOrder/v1/getReturnOrder?orderId=' + this.id)
      .subscribe(
        res => {
          this.saveRequestData(res);
        },
        err => {
          if(err && err.status!=0){
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = err;

          }
          this.http.onEnd();
        }
      );
  }

  public saveRequestData(res) {
    if (res.responseStatus == 'Success') {
      this.finalFormData = res.returnReqDto;
      this.finalFormData.status = res.returnReqDto.status;
      console.log(res.returnReqDto['status'],"**************************************************");
      if(res.returnReqDto['status']=="REJECTED_FOR_INCOMPLETENESS"){
        this.finalFormData.status="REJECTED FOR INCOMPLETENESS"
      }
      this.commonService.changeViewData(res.returnReqDto);
      if (
        this.finalFormData.returnItemUploadFlag == 2 ||
        this.finalFormData.returnItemUploadFlag == 'INVOICE_NUMBER'
      ) {
        this.item_list = this.finalFormData.returnOrder.items;
        this.setReturnData();
      } else if (
        this.finalFormData.returnItemUploadFlag == 0 ||
        this.finalFormData.returnItemUploadFlag == 1 ||
        this.finalFormData.returnItemUploadFlag == 'INSERT_MANUAL' ||
        this.finalFormData.returnItemUploadFlag == 'UPLOAD_FILE'
      ) {
        this.item_list = this.finalFormData.returnOrder.items;
        this.setReturnDataManual();
      }
      // if(this.finalFormData.returnOrder && this.finalFormData.returnOrder.items){
      // this.item_list = this.finalFormData.returnOrder.items;
      //     this.setReturnData();
      // }
    } else {
      this.dialogRef = this.dialog.open(dialogComponent);
      this.dialogRef.componentInstance.msg = res.errorMessage;
    }
    this.http.onEnd();
  }

  public getReasonList() {
    this.http.getRequest('tradePartnerDetails/v1/getReasonCode').subscribe(
      res => {
        this.saveReasonList(res);
      },
      err => {
        if(err && err.status!=0){
          this.dialogRef = this.dialog.open(dialogComponent);
          this.dialogRef.componentInstance.msg = err;

        }
        this.http.onEnd();
      }
    );
  }

  public saveReasonList(res) {
    if (res && res.items) {
      this.reasonList = res.items;
      this.sessionHandler.saveItem('reasons', JSON.stringify(this.reasonList));
      for (let r in this.reasonList) {
        if (
          this.finalFormData.returnOrder.reason == this.reasonList[r].reasonCode
        ) {
          this.reason = this.reasonList[r].reason;
        }
      }
    }
    this.http.onEnd();
  }

  public setReturnData() {
    this.reasonList = JSON.parse(this.sessionHandler.getItem('reasons'));
    if (this.reasonList == null || this.reasonList.length < 0) {
      this.getReasonList();
    } else {
      for (let r in this.reasonList) {
        if (
          this.finalFormData.returnOrder.reason == this.reasonList[r].reasonCode
        ) {
          this.reason = this.reasonList[r].reason;
        }
      }
    }
    if (this.item_list) {
      this.isItem = true;
      if (this.item_list && this.item_list.length > 0) {
        let dataCount = 0;
        for (let i in this.item_list) {
          for (let j in this.item_list[i]) {
            if (this.item_list[i]['data']) {
              if (dataCount == 0) {
                if (this.item_list[i]['data'].modelNumber) {
                  
                  this.setItemList();
                  dataCount++;
                } else {
                  this.setItemDataForEdit();
                  dataCount++;
                }
              }
            } else {
              if (dataCount == 0) {
                if (this.item_list[i][j].modelNumber) {
                  this.setItemList();
                  dataCount++;
                } else {
                  this.setItemDataForEdit();
                  dataCount++;
                }
              }
            }
          }
        }
      }
    }
  }

  public isItemInArray(array, item) {
    for (var i = 0; i < array.length; i++) {
      // This if statement depends on the format of your array
      if (array[i].value == item) {
        return true; // Found it
      }
    }
    return false; // Not found
  }

  public setItemList() {
    for (let i in this.item_list) {
      this.manualListValid[i] = [];
      this.showEditSerial[i] = [];
      this.serialNumberList[i] = [];
      this.tempSerialList[i] = [];
      this.serialNumberInput[i] = [];
      for (let j in this.item_list[i]) {
        this.invoice_no_array[i] = this.item_list[i][j]['invoiceDocumentID'];
        if (parseInt(this.item_list[i][j].invoicedQuantity) > 0) {
          this.manualListValid[i][j] = this.item_list[i][j].valid;
          this.showEditSerial[i][j] = false;
          this.tempSerialList[i][j] = [];
          this.serialNumberList[i][j] = [];
          this.serialNumberInput[i][j] = [];

          if (
            this.item_list[i][j].serialNumber &&
            Object.keys(this.item_list[i][j].serialNumber).length > 0
          ) {
            for (let x in this.item_list[i][j].serialNumber) {
              if (
                this.item_list[i][j].serialNumber[x] &&
                Object.keys(this.item_list[i][j].serialNumber[x]).length > 0
              ) {
                if (
                  !this.isItemInArray(
                    this.serialNumberList[i][j],
                    this.item_list[i][j].serialNumber[x].value
                  )
                ) {
                  this.serialNumberList[i][j].push(
                    this.item_list[i][j].serialNumber[x]
                  );
                }
              }
            }
          }

          let count = 0;
          for (let x in this.serialNumberList[i][j]) {
            if (this.serialNumberList[i][j][x].value) {
              count++;
            }
          }

          if (count < parseInt(this.item_list[i][j].invoicedQuantity)) {
            this.showEditSerial[i][j] = true;
          }
        }
      }
    }
    this.showList = true;
  }

  public setItemDataForEdit() {
    console.log('entr');
    if (this.item_list) {
      let serials: any = [];
      let qty: any = [];
      let models: any = [];
      let final: any = [];
      let items = [];
      let itemList: any = [];

      for (let i in this.item_list) {
        serials[i] = [];
        qty[i] = [];
        models[i] = [];
        final[i] = [];
        let dummyItems: itemClassEdit[] = [];
        items.push(dummyItems);

        itemList[i] = [];
        if (this.item_list[i]['data']) {
          for (let j in this.item_list[i]['data']) {
            if (this.item_list[i]['data'][j]) {
              if (!this.item_list[i]['data'][j].id) {
                this.item_list[i]['data'][j].id = '';
              }
              let reason = null;
              if (this.item_list[i]['data'][j].reasonCode) {
                reason = this.item_list[i]['data'][j].reasonCode;
              }
              let maxQuantity = '';
              if (
                this.item_list[i]['data'][j].maxQuantity &&
                this.item_list[i]['data'][j].maxQuantity != ''
              ) {
                maxQuantity = this.item_list[i]['data'][j].maxQuantity;
              }
              if (this.item_list[i]['data'][j].serialNumber) {
                items[i].push(
                  new itemClassEdit(
                    this.item_list[i]['data'][j].id,
                    this.item_list[i]['data'][j].invoiceDocumentID,
                    this.item_list[i]['data'][j].customerMaterialNumber,
                    this.item_list[i]['data'][j].serialNumber,
                    this.item_list[i]['data'][j].itemID,
                    reason,
                    this.item_list[i]['data'][j].invoicedQuantity,
                    maxQuantity,
                    true
                  )
                );
              } else {
                items[i].push(
                  new itemClassEdit(
                    this.item_list[i]['data'][j].id,
                    this.item_list[i]['data'][j].invoiceDocumentID,
                    this.item_list[i]['data'][j].customerMaterialNumber,
                    null,
                    this.item_list[i]['data'][j].itemID,
                    reason,
                    this.item_list[i]['data'][j].invoicedQuantity,
                    maxQuantity,
                    true
                  )
                );
              }
            }
          }
        } else {
          for (let j in this.item_list[i]) {
            if (this.item_list[i][j]) {
              if (!this.item_list[i][j].id) {
                this.item_list[i][j].id = '';
              }
              let reason = null;
              if (this.item_list[i][j].reasonCode) {
                reason = this.item_list[i][j].reasonCode;
              }
              let maxQuantity = '';
              if (
                this.item_list[i][j].maxQuantity &&
                this.item_list[i][j].maxQuantity != ''
              ) {
                maxQuantity = this.item_list[i][j].maxQuantity;
              }
              if (this.item_list[i][j].serialNumber) {
                items[i].push(
                  new itemClassEdit(
                    this.item_list[i][j].id,
                    this.item_list[i][j].invoiceDocumentID,
                    this.item_list[i][j].customerMaterialNumber,
                    this.item_list[i][j].serialNumber,
                    this.item_list[i][j].itemID,
                    reason,
                    this.item_list[i][j].invoicedQuantity,
                    maxQuantity,
                    true
                  )
                );
              } else {
                items[i].push(
                  new itemClassEdit(
                    this.item_list[i][j].id,
                    this.item_list[i][j].invoiceDocumentID,
                    this.item_list[i][j].customerMaterialNumber,
                    null,
                    this.item_list[i][j].itemID,
                    reason,
                    this.item_list[i][j].invoicedQuantity,
                    maxQuantity,
                    true
                  )
                );
              }
            }
          }
        }
      }

      for (let i in items) {
        for (let j in items[i]) {
          if (models[i].indexOf(items[i][j].modelNumber) == -1) {
            models[i].push(items[i][j].modelNumber);
          }
        }
      }

      for (let i in models) {
        for (let j in models[i]) {
          serials[i][models[i][j]] = [];
          qty[i][models[i][j]] = 0;

          for (let k in items) {
            for (let l in items[k]) {
              let rawSerial = {};
              if (models[i][j] == items[k][l].modelNumber) {
                qty[i][models[i][j]] += parseInt(items[k][l].invoicedQuantity);
                if (items[k][l].id) {
                  rawSerial['id'] = items[k][l].id;
                } else {
                  rawSerial['id'] = '';
                }
                if (items[k][l].serialNumber) {
                  rawSerial['value'] = items[k][l].serialNumber;
                } else {
                  rawSerial['value'] = '';
                }
                serials[i][models[i][j]].push(rawSerial);
              }
            }
          }
        }
      }

      for (let m in models) {
        for (let n in models[m]) {
          for (let i in items) {
            for (let j in items[i]) {
              if (models[m][n] == items[i][j].modelNumber) {
                final[i][j] = [];
                final[i][j] = items[i][j];
                break;
              }
            }
          }
        }
      }
      for (let f in final) {
        for (let g in final[f]) {
          for (let s in serials) {
            for (let t in serials[s]) {
              if (final[f][g].modelNumber == t) {
                final[f][g].invoicedQuantity = qty[s][t];
                final[f][g].serialNumber = serials[s][t];
              }
            }
          }
          itemList[f].push(final[f][g]);
        }
      }
      this.item_list = itemList;
      if (this.item_list && this.item_list.length > 0) {
        this.setItemList();
      }
    }
  }

  public delete(i, j) {
    this.clearDuplicateWarning();
    this.serialNumberList[i].splice(j, 1);
    this.serialNumberInput[i].splice(j, 1);
    this.showEditSerial[i].splice(j, 1);
    this.item_list[i].splice(j, 1);
    this.checkItemCount();
  }

  public addSerialList(i, j) {
    this.clearDuplicateWarning();
    console.log("data is : "+JSON.stringify(this.item_list[i][j]))
    if (this.serialNumberInput[i][j] && this.serialNumberInput[i][j] != '') {
      this.serialNumberInput[i][j] = this.serialNumberInput[i][j].toUpperCase();
      if (this.SerialValidation(this.serialNumberInput[i][j])) {
        let count = 0;
        for (let s in this.serialNumberList[i][j]) {
          if (
            this.serialNumberList[i][j][s].value &&
            this.serialNumberList[i][j][s].value != ''
          ) {
            if (
              this.serialNumberList[i][j][s].value ==
              this.serialNumberInput[i][j]
            ) {
              count++;
            }
          }
        }
        if (count == 0) {
          let rawSerial: any = {};
          rawSerial.id = '';
          rawSerial.value = this.serialNumberInput[i][j];
          this.serialNumberList[i][j].push(rawSerial);
        } else {
          this.dialogRef = this.dialog.open(dialogComponent, {
            disableClose: true
          });
          this.dialogRef.componentInstance.msg =
            'Same serial number already exists for this model number. Please enter a different serial number.';
        }
        this.compareSerialQuantity(i, j);
      } else {
        this.dialogRef = this.dialog.open(dialogComponent, {
          disableClose: true
        });
        this.dialogRef.componentInstance.msg =
          'Invalid Serial Number. Please enter valid serial number of length 9 or 10.';
      }
    }

//input field blank
    this.serialNumberInput[i] = [];
  }

  public deleteSerialList(i, j, s, items) {
    this.clearDuplicateWarning();
    delete this.serialNumberList[i][j][s];
    //rearrange index of serial list
    let dummy = [];
    for (let s in this.serialNumberList[i][j]) {
      if (this.serialNumberList[i][j][s]) {
        dummy.push(this.serialNumberList[i][j][s]);
      }
    }
    this.serialNumberList[i][j] = dummy;
    this.compareSerialQuantity(i, j);
  }

  public checkItemCount() {
    let validCount = 0;
    let qtyCount = 0;
    let serialCheck = [];
    let serialCount = 0;
    if (Object.keys(this.item_list).length > 0) {
      for (let i in this.item_list) {
        serialCheck.push([]);
        for (let j in this.item_list[i]) {
          if (this.manualListValid[i][j]) {
            validCount++;
          }
          if (parseInt(this.item_list[i][j].invoicedQuantity) > 0) {
            qtyCount++;
          }
          if (this.compareSerialQuantity(i, j)) {
            serialCheck[i][j] = true;
          } else {
            serialCheck[i][j] = false;
          }
        }
      }
    }
    for (let s in serialCheck) {
      if (!serialCheck[s]) {
        serialCount++;
      }
    }
    if (
      validCount == 0 ||
      this.item_list.length == 0 ||
      qtyCount == 0 ||
      serialCount != 0
    ) {
      this.isItem = false;
    } else {
      this.isItem = true;
    }
  }

  
public SerialValidation(value: string) {
    if (!value) return false;

    if (value.length === 9) {
        return /^[Ww][A-Za-z0-9]([0-4][0-9]|5[0-3])\d{5}$/.test(value);
    } else if (value.length === 10) {
        return /^[WwYyDd][A-Za-z][A-Za-z0-9]([0-4][0-9]|5[0-3])\d{5}$/.test(value);
    } else {
        return false;
    }
}


  public compareSerialQuantity(i, j) {
    //compare serial count and quantity

    if (this.isEdit) {
      let count = 0;
      for (let s in this.serialNumberList[i][j]) {
        if (this.serialNumberList[i][j][s].value != '') {
          count++;
        }
      }
      if (count > parseInt(this.item_list[i][j].invoicedQuantity)) {
        this.showEditSerial[i][j] = false;
        this.showError(
          'Total count of serial numbers for item cannot be greater than item quantity. Please remove serial number(s) or change your quantity.',
          false
        );
        return false;
      }
      if (count < parseInt(this.item_list[i][j].invoicedQuantity)) {
        this.showEditSerial[i][j] = true;
        return true;
      }
      if (count == parseInt(this.item_list[i][j].invoicedQuantity)) {
        this.showEditSerial[i][j] = false;
        return true;
      }
    } else {
      if (
        this.serialNumberList[i][j] &&
        this.serialNumberList[i][j].length >
        parseInt(this.item_list[i][j].invoicedQuantity)
      ) {
        this.showEditSerial[i][j] = false;
        this.showError(
          'Total count of serial numbers for item cannot be greater than item quantity. Please remove serial number(s) or change your quantity.',
          false
        );
        return false;
      }
      if (
        this.serialNumberList[i][j] &&
        this.serialNumberList[i][j].length <
        parseInt(this.item_list[i][j].invoicedQuantity)
      ) {
        this.showEditSerial[i][j] = true;
        return true;
      }
      if (
        this.serialNumberList[i][j] &&
        this.serialNumberList[i][j].length ==
        parseInt(this.item_list[i][j].invoicedQuantity)
      ) {
        this.showEditSerial[i][j] = false;
        return true;
      }
    }
  }

  public showError(msg, isLogout) {
    this.dialogRef = this.dialog.open(dialogComponent, { disableClose: true });
    this.dialogRef.componentInstance.msg = msg;
    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (isLogout) {
          localStorage.clear();
          this.router.navigateByUrl('/login');
        }
      }
      this.dialogRef = null;
    });
  }

  public saveSerialNumber(i) {
    this.showField[i] = !this.showField[i];
    this.item_list[i].serialNumber = this.serialNumberList[i];
  }

  public goToPreviousPage() {
    if (!isNaN(this.id)) {
      this.router.navigateByUrl('/app/requests/return/' + this.id);
    } else {
      this.router.navigateByUrl('/app/requests/return');
    }
  }

  public convertItemsArray() {
    let items = [];
    let newItemList = [];
    let final = [];
    let serialCount = [];
    if (this.isEdit) {
      let newEntry = false;
      for (let i in this.item_list) {
        items[i] = [];
        for (let j in this.item_list[i]) {
          items[i][j] = [];
          if (this.item_list[i][j].id != '') {
            this.item_list[i][j].serialNumber = this.serialNumberList[i][j];
            if (this.item_list[i][j].serialNumber.length > 0) {
              for (let s in this.item_list[i][j].serialNumber) {
                items[i][j].push(this.item_list[i][j].serialNumber[s]);
              }
            } else if (this.item_list[i][j].id) {
              let rawSerial = {};
              rawSerial['id'] = this.item_list[i][j].id;
              rawSerial['value'] = '';
              items[i][j].push(rawSerial);
            } else {
              let rawSerial = {};
              rawSerial['id'] = '';
              rawSerial['value'] = '';
              items[i][j].push(rawSerial);
            }
            //check if its a new entry in edit mode
            if (this.item_list[i][j].id == '') {
              newEntry = true;
            }
          }
        }
      }

      //if New entry is present, then continue as creation
      let count = [];
      let serialCounter = [];
      let loopCount;
      let blankEntry = [];
      for (let i in this.item_list) {
        for (let j in this.item_list[i]) {
          count[i] = [];
          serialCounter[i] = [];
          if (this.item_list[i][j].id == '') {
            serialCounter[i][j] = 0;
            this.item_list[i].serialNumber = this.serialNumberList[i][j];
            count[i][j] = 0;
            if (this.item_list[i][j].serialNumber.length > 0) {
              for (let s in this.item_list[i][j].serialNumber) {
                count[i]++;
              }
            }
          }
        }
      }

      for (let i in this.item_list) {
        blankEntry[i] = [];
        for (let j in this.item_list[i]) {
          if (this.item_list[i][j].id == '') {
            items[i][j] = [];
            blankEntry[i][j] = false;
            if (
              count[i][j] != 0 &&
              count[i][j] < parseInt(this.item_list[i][j].invoicedQuantity)
            ) {
              loopCount = count[i][j] + 1;
            }
            if (
              count[i][j] != 0 &&
              count[i][j] == parseInt(this.item_list[i][j].invoicedQuantity)
            ) {
              loopCount = count[i][j];
            }
            if (count[i][j] == 0) {
              loopCount = 1;
            }
            for (var x = 0; x < loopCount; x++) {
              if (
                count[i][j] != serialCounter[i][j] &&
                this.item_list[i][j].serialNumber.length > 0
              ) {
                for (let s in this.item_list[i][j].serialNumber) {
                  serialCounter[i][j]++;
                  items[i][j].push(this.item_list[i][j].serialNumber[s]);
                }
              } else if (
                !blankEntry[i][j] &&
                count[i][j] == serialCounter[i][j]
              ) {
                blankEntry[i][j] = true;
                let rawSerial = {};
                rawSerial['id'] = '';
                rawSerial['value'] = '';
                items[i][j].push(rawSerial);
              }
            }
          }
        }
      }
    } else {
      // Creation mode

      let count = [];
      let serialCounter = [];
      for (let i in this.item_list) {
        serialCounter[i] = [];
        count[i] = [];
        for (let j in this.item_list[i]) {
          serialCounter[i][j] = 0;
          count[i][j] = 0;
          serialCount[this.item_list[i][j].invoiceDocumentID] = [];
          this.item_list[i][j].serialNumber = this.serialNumberList[i][j];
          if (this.item_list[i][j].serialNumber.length > 0) {
            for (let s in this.item_list[i][j].serialNumber) {
              count[i][j]++;
            }
          }
        }
      }

      let loopCount;
      let blankEntry = [];
      for (let i in this.item_list) {
        items[i] = [];
        blankEntry[i] = [];
        for (let j in this.item_list[i]) {
          items[i][j] = [];
          blankEntry[i][j] = false;

          if (
            count[i][j] != 0 &&
            count[i][j] < parseInt(this.item_list[i][j].invoicedQuantity)
          ) {
            loopCount = count[i][j] + 1;
          }
          if (
            count[i][j] != 0 &&
            count[i][j] == parseInt(this.item_list[i][j].invoicedQuantity)
          ) {
            loopCount = count[i][j];
          }
          if (count[i][j] == 0) {
            loopCount = 1;
          }

          for (var x = 0; x < loopCount; x++) {
            if (
              count[i][j] != serialCounter[i][j] &&
              this.item_list[i][j].serialNumber.length > 0
            ) {
              for (let s in this.item_list[i][j].serialNumber) {
                serialCounter[i][j]++;
                items[i][j].push(this.item_list[i][j].serialNumber[s]);
              }
            } else if (
              !blankEntry[i][j] &&
              count[i][j] == serialCounter[i][j]
            ) {
              blankEntry[i][j] = true;
              let rawSerial = {};
              rawSerial['id'] = '';
              rawSerial['value'] = '';
              items[i][j].push(rawSerial);
            }
          }
        }
      }
    }

    let pushCount = [];
    for (let i in items) {
      newItemList[i] = [];
      pushCount[i] = [];
      for (let j in items[i]) {
        pushCount[i][j] = 0;
        newItemList[i][j] = [];
        for (let x in items[i][j]) {
          if (pushCount[i][j] != this.item_list[i][j].invoicedQuantity) {
            newItemList[i][j].push(Object.assign({}, this.item_list[i][j]));
          }
          pushCount[i][j]++;
        }
      }
    }
    for (let i in newItemList) {
      for (let j in newItemList[i]) {
        let count = 0;
        for (let n in newItemList[i][j]) {
          if (items[i][j][n].value != null && items[i][j][n].value != '') {
            count++;
            newItemList[i][j][n].invoicedQuantity = 1;
            newItemList[i][j][n].serialNumber = items[i][j][n].value;
          } else {
            newItemList[i][j][n].serialNumber = items[i][j][n].value;
            if (count > 0) {
              newItemList[i][j][n].invoicedQuantity -= 1;
            }
          }
          newItemList[i][j][n].id = items[i][j][n].id;
          final.push(newItemList[i][j][n]);
        }
      }
    }

    for (let i in this.item_list) {
      for (let j in this.item_list[i]) {
        if (serialCount[this.item_list[i][j].invoiceDocumentID]) {
          serialCount[this.item_list[i][j].invoiceDocumentID][
            this.item_list[i][j].modelNumber
          ] = {};
          serialCount[this.item_list[i][j].invoiceDocumentID][
            this.item_list[i][j].modelNumber
          ].count = 0;
          serialCount[this.item_list[i][j].invoiceDocumentID][
            this.item_list[i][j].modelNumber
          ].quantity = this.item_list[i][j].invoicedQuantity;
          for (let f in final) {
            if (
              this.item_list[i][j].invoiceDocumentID ==
              final[f].invoiceDocumentID
            ) {
              if (
                this.item_list[i][j].modelNumber == final[f].modelNumber &&
                final[f].serialNumber != ''
              ) {
                serialCount[this.item_list[i][j].invoiceDocumentID][
                  this.item_list[i][j].modelNumber
                ].count++;
              }
            }
          }
        }
      }
    }

    for (let f in final) {
      for (let s in serialCount) {
        for (let model in serialCount[s]) {
          if (final[f].invoiceDocumentID == s) {
            if (final[f].modelNumber == model) {
              if (final[f].serialNumber == '') {
                if (
                  serialCount[s][model].quantity !=
                  parseInt(serialCount[s][model].count)
                ) {
                  final[f].invoicedQuantity =
                    parseInt(serialCount[s][model].quantity) -
                    parseInt(serialCount[s][model].count);
                }
              }
            }
          }
        }
      }
    }

    this.finalFormData.returnOrder.items = final;
    for (let i in this.finalFormData.returnOrder) {
      if (i == 'invoiceNumber') {
        this.finalFormData.returnOrder[i] = '';
      }
    }
    return true;
  }

  public handleSubmitButtonClick() {
  if (this.showDuplicateDialog) {
    this.proceedAfterDuplicateWarning();
    return;
  }

  if (!this.isAdmin && !this.isOTD && !this.isEndConsumner) {
    this.showDialog();
  } else {
    this.submit();
  }
}

  public showDialog() {
    this.dialogRef = this.dialog.open(termsDialogComponent, {
      disableClose: true
    });
    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.submit();
      }
      this.dialogRef = null;
    });
  }

  public save() {
    this.finalFormData.email = this.userData.email;
    this.finalFormData.userId = this.userData.userId;
    this.finalFormData.requestOrder.fileUrl=null;
    this.finalFormData['fileUrlsDTO']=this.commonService.getWrtImageData();
    if (this.isAdmin || this.isOTD || this.isEndConsumner) {
      this.finalFormData.tradePartnerId = this.finalFormData.tradeId;
    } else {
      this.finalFormData.tradePartnerId = this.userData.tradePartnerId;
    }
    if (
      this.finalFormData.returnItemUploadFlag == 0 ||
      this.finalFormData.returnItemUploadFlag == 1 ||
      this.finalFormData.returnItemUploadFlag == 'INSERT_MANUAL' ||
      this.finalFormData.returnItemUploadFlag == 'UPLOAD_FILE'
    ) {
      if (this.convertItemsArrayManual()) {
        this.http
          .postRequest(this.finalFormData, 'returnOrder/v1/saveReturnOrder')
          .subscribe(
            res => {
              this.saveResponse(res, 'draft');
            },
            err => {
              if(err && err.status!=0){
                this.dialogRef = this.dialog.open(dialogComponent);
                this.dialogRef.componentInstance.msg = 'Save Failed';

              }
              this.http.onEnd();
            }
          );
      }
    } else if (this.convertItemsArray()) {
      this.http
        .postRequest(this.finalFormData, 'returnOrder/v1/saveReturnOrder')
        .subscribe(
          res => {
            this.saveResponse(res, 'draft');
          },
          err => {
            if(err && err.status!=0){
              this.dialogRef = this.dialog.open(dialogComponent);
              this.dialogRef.componentInstance.msg = 'Save Failed';

            }
            this.http.onEnd();
          }
        );
    }
  }

  public saveResponse(res, api) {
    this.http.onEnd();
    console.log(res);
    if (res.status == 'Success') {
      this.dialogRef = this.dialog.open(dialogComponent, {
        disableClose: true
      });
      if (api == 'draft') {
        this.dialogRef.componentInstance.msg = 'Request Saved As Draft';
      }
      if (api == 'submit') {
        this.dialogRef.componentInstance.msg = 'Request submitted successfully';
      }

    } else {
      //if (res.status == 'Error') {
      this.dialogRef = this.dialog.open(dialogComponent);

      if (res.errorMessage.indexOf('WebServiceException') != -1
        || res.errorMessage.indexOf('SOAPFaultException') != -1) {
        this.dialogRef.componentInstance.msg = res.errorMessage + ' ! ' + 'Sorry, we have encountered SAP server communication error. Please contact administrator for this request status.';
      } else {
        this.dialogRef.componentInstance.msg = res.errorMessage;
      }
    }
    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.commonService.setData(null);
        this.router.navigateByUrl('/app/dashboard');
      }
      this.dialogRef = null;
    });
  }

  public submit() {

if (this.showDuplicateDialog) {
    this.proceedAfterDuplicateWarning();
    return;
  }

  this.prepareSubmitPayload();

  if (
    this.finalFormData.returnItemUploadFlag == 0 ||
    this.finalFormData.returnItemUploadFlag == 1 ||
    this.finalFormData.returnItemUploadFlag == 'INSERT_MANUAL' ||
    this.finalFormData.returnItemUploadFlag == 'UPLOAD_FILE'
  ) {
    if (this.convertItemsArrayManual()) {
      this.checkDuplicateReturnOrderBeforeSapSubmit();
    }
  } else {
    if (this.convertItemsArray()) {
      this.checkDuplicateReturnOrderBeforeSapSubmit();
    }
  }
}
public prepareSubmitPayload() {
  this.finalFormData.email = this.userData.email;
  this.finalFormData.requestOrder.fileUrl = null;
  this.finalFormData.userId = this.userData.userId;

  if (this.isAdmin || this.isOTD || this.isEndConsumner) {
    this.finalFormData.tradePartnerId = this.finalFormData.tradeId;
  } else {
    this.finalFormData.tradePartnerId = this.userData.tradePartnerId;
  }

  this.finalFormData['fileUrlsDTO'] = this.commonService.getWrtImageData();
}
public checkDuplicateReturnOrderBeforeSapSubmit() {
  const duplicateItems = this.buildDuplicateCheckItemsFromFinalPayload();

  if (!duplicateItems || duplicateItems.length === 0) {
    this.duplicateReturnOrders = [];
    this.submitToSap();
    return;
  }

  const payload = {
    returnOrder: {
      items: duplicateItems
    }
  };

  this.isDuplicateCheckInProgress = true;

  this.http
    .postRequest(payload, 'returnOrder/v1/checkDuplicateReturnOrder')
    .subscribe(
      (res: any) => {
        this.isDuplicateCheckInProgress = false;

        if (
          res &&
          res.responseCode == 200 &&
          res.modelList &&
          res.modelList.length > 0
        ) {
          this.http.onEnd();
          this.duplicateReturnOrders =
            this.normaliseDuplicateReturnOrders(res.modelList);

          this.showDuplicateDialog = true;
        } else {
          this.http.onEnd();
          this.duplicateReturnOrders = [];
          this.submitToSap();
        }
      },
      err => {
        this.isDuplicateCheckInProgress = false;

        this.dialogRef = this.dialog.open(dialogComponent, {
          disableClose: true
        });

        this.dialogRef.componentInstance.msg =
          err && err.message
            ? err.message
            : 'Unable to check duplicate return order. Please try again.';

        this.http.onEnd();
      }
    );
}
public buildDuplicateCheckItemsFromFinalPayload() {
  const duplicateItems = [];

  if (
    !this.finalFormData ||
    !this.finalFormData.returnOrder ||
    !this.finalFormData.returnOrder.items
  ) {
    return duplicateItems;
  }

  const items = this.finalFormData.returnOrder.items;

  for (let i in items) {
    const item = items[i];

    if (!item) {
      continue;
    }

    const modelNumber =
      item.modelNumber ||
      item.customerMaterialNumber ||
      item.spareNumber ||
      '';

    if (!modelNumber) {
      continue;
    }

    duplicateItems.push({
      modelNumber: modelNumber,
      serialNumber: item.serialNumber || ''
    });
  }

  return duplicateItems;
}
public normaliseDuplicateReturnOrders(modelList) {
  const duplicateOrders = [];

  for (let i in modelList) {
    const row = modelList[i];

    duplicateOrders.push({
      orderId: row.returnorder_id || '',
      requestId: row.saporder_id || '',
      modelNumber: row.material_number || '',
      serialNumber: row.serial_number || ''
    });
  }

  return duplicateOrders;
}
public submitToSap() {
  const saveURL = 'saveReturnOrderWithSAP';

  this.http.postRequest(this.finalFormData, saveURL).subscribe(
    res => {
      this.saveResponse(res, 'submit');
    },
    err => {
      if (err && err.status != 0) {
        this.dialogRef = this.dialog.open(dialogComponent);

        this.dialogRef.componentInstance.msg =
          'Sorry, we have encountered SAP server communication error. Please contact administrator for this request status.';
      }

      this.http.onEnd();

      if (this.dialogRef) {
        this.dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.commonService.setData(null);
            this.router.navigateByUrl('/app/dashboard');
          }
          this.dialogRef = null;
        });
      }
    }
  );
}
public proceedAfterDuplicateWarning() {
  this.showDuplicateDialog = false;
  this.submitToSap();
}

public cancelDuplicateSubmit() {
  this.showDuplicateDialog = false;
}
public clearDuplicateWarning() {
  this.showDuplicateDialog = false;
  this.duplicateReturnOrders = [];
}
  public openExistingReturnOrder(orderId) {
    if (!orderId) {
      return;
    }


    const baseUrl = window.location.origin;

    window.open(
      `${baseUrl}/#/app/view/create/${orderId}`,
      '_blank'
    );

  }
  // public submit() {
  //   // let saveURL= 'saveReturnOrderWithSAP.do';
  //   let saveURL = 'saveReturnOrderWithSAP';
  //   this.finalFormData.email = this.userData.email;
  //   this.finalFormData.requestOrder.fileUrl=null;
  //   this.finalFormData.userId = this.userData.userId;
  //   if (this.isAdmin || this.isOTD || this.isEndConsumner) {
  //     this.finalFormData.tradePartnerId = this.finalFormData.tradeId;
  //   } else {
  //     this.finalFormData.tradePartnerId = this.userData.tradePartnerId;
  //   }
  //   this.finalFormData['fileUrlsDTO']=this.commonService.getWrtImageData();

  //   console.log(this.finalFormData)
  //   if (
  //     this.finalFormData.returnItemUploadFlag == 0 ||
  //     this.finalFormData.returnItemUploadFlag == 1 ||
  //     this.finalFormData.returnItemUploadFlag == 'INSERT_MANUAL' ||
  //     this.finalFormData.returnItemUploadFlag == 'UPLOAD_FILE'
  //   ) {
  //     if (this.convertItemsArrayManual()) {
  //       this.http.postRequest(this.finalFormData, saveURL).subscribe(
  //         res => {
  //           this.saveResponse(res, 'submit');
  //         },
  //         err => {
  //           if(err && err.status!=0){
  //             this.dialogRef = this.dialog.open(dialogComponent);
  //             this.dialogRef.componentInstance.msg = 'Sorry, we have encountered SAP server communication error. Please contact administrator for this request status.';

  //           }
  //           this.http.onEnd();
  //           this.dialogRef.afterClosed().subscribe(result => {
  //             if (result) {
  //               this.commonService.setData(null);
  //               this.router.navigateByUrl('/app/dashboard');
  //             }
  //             this.dialogRef = null;
  //           });
  //         }
  //       );
  //     }
  //   } else if (this.convertItemsArray()) {
  //     this.http.postRequest(this.finalFormData, saveURL).subscribe(
  //       res => {
  //         this.saveResponse(res, 'submit');
  //       },
  //       err => {
  //         if(err && err.status!=0){
  //           this.dialogRef = this.dialog.open(dialogComponent);
  //           this.dialogRef.componentInstance.msg = 'Submit Failed';

  //         }
  //         this.http.onEnd();
  //       }
  //     );
  //   }
  // }

  //FOR MANUAL/FILEUPLOAD

  public setReturnDataManual() {
    this.reasonList = JSON.parse(this.sessionHandler.getItem('reasons'));
    if (this.reasonList == null || this.reasonList.length < 0) {
      this.getReasonList();
    } else {
      for (let r in this.reasonList) {
        if (
          this.finalFormData.returnOrder.reason == this.reasonList[r].reasonCode
        ) {
          this.reason = this.reasonList[r].reason;
        }
      }
    }

    if (this.item_list) {
      this.isItem = true;
      if (this.item_list[0].modelNumber) {
        this.setItemListManual();
      } else {
        this.setItemDataForEditManual();
      }
    }
  }

  public setItemListManual() {
    for (let i in this.item_list) {
      if (this.item_list[i].invoicedQuantity > 0) {
        this.manualListValid[i] = this.item_list[i].valid;
        this.showField[i] = false;
        this.showEditSerial[i] = false;
        this.tempSerialList[i] = [];
        this.serialNumberList[i] = [];
        if (
          this.item_list[i].serialNumber &&
          Object.keys(this.item_list[i].serialNumber).length > 0
        ) {
          for (let x in this.item_list[i].serialNumber) {
            if (
              this.item_list[i].serialNumber[x] &&
              Object.keys(this.item_list[i].serialNumber[x]).length > 0
            ) {
              if (
                !this.isItemInArray(
                  this.serialNumberList[i],
                  this.item_list[i].serialNumber[x].value
                )
              ) {
                this.serialNumberList[i].push(
                  this.item_list[i].serialNumber[x]
                );
              }
            }
          }
        }
      }
      let count = 0;
      for (let x in this.serialNumberList[i]) {
        if (this.serialNumberList[i][x].value) {
          count++;
        }
      }
      if (count < parseInt(this.item_list[i].invoicedQuantity)) {
        this.showEditSerial[i] = true;
      }
    }
  }

  public setItemDataForEditManual() {
    if (this.item_list) {
      let serials: any = [];
      let qty: any = [];
      let models: any = [];
      let final: any = [];
      let items: itemClass[] = [];
      let itemList: any = [];
      for (let i in this.item_list) {
        if (this.item_list[i]) {
          if (!this.item_list[i].id) {
            this.item_list[i].id = '';
          }
          let reason = null;
          if (this.item_list[i].reasonCode) {
            reason = this.item_list[i].reasonCode;
          }
          let maxQuantity = '';
          if (
            this.item_list[i].maxQuantity &&
            this.item_list[i].maxQuantity != ''
          ) {
            maxQuantity = this.item_list[i].maxQuantity;
          }
          if (this.item_list[i].serialNumber) {
            items.push(
              new itemClassEditManual(
                this.item_list[i].id,
                this.item_list[i].customerMaterialNumber,
                this.item_list[i].serialNumber,
                this.item_list[i].itemID,
                reason,
                this.item_list[i].invoicedQuantity,
                maxQuantity,
                true
              )
            );
          } else {
            items.push(
              new itemClassEditManual(
                this.item_list[i].id,
                this.item_list[i].customerMaterialNumber,
                null,
                this.item_list[i].itemID,
                reason,
                this.item_list[i].invoicedQuantity,
                maxQuantity,
                true
              )
            );
          }
        }
      }

      for (let i in items) {
        if (models.indexOf(items[i].modelNumber) == -1) {
          models.push(items[i].modelNumber);
        }
      }

      for (let m in models) {
        serials[models[m]] = [];
        qty[models[m]] = 0;
        for (let i in items) {
          let rawSerial = {};
          if (models[m] == items[i].modelNumber) {
            qty[models[m]] += parseInt(items[i].invoicedQuantity);
            if (items[i].id) {
              rawSerial['id'] = items[i].id;
            } else {
              rawSerial['id'] = '';
            }
            if (items[i].serialNumber) {
              rawSerial['value'] = items[i].serialNumber;
            } else {
              rawSerial['value'] = '';
            }
            serials[models[m]].push(rawSerial);
          }
        }
      }

      for (let m in models) {
        for (let i in items) {
          if (models[m] == items[i].modelNumber) {
            final[i] = [];
            final[i] = items[i];
            break;
          }
        }
      }

      for (let f in final) {
        for (let s in serials) {
          if (final[f].modelNumber == s) {
            final[f].invoicedQuantity = qty[s];
            final[f].serialNumber = serials[s];
          }
        }
        itemList.push(final[f]);
      }
      this.item_list = itemList;
      if (this.item_list && this.item_list.length > 0) {
        this.setItemList();
      }
    }
  }

  public deleteManual(i) {
    this.clearDuplicateWarning();
    this.serialNumberList.splice(i, 1);
    this.serialNumberInput.splice(i, 1);
    this.showEditSerial.splice(i, 1);
    this.item_list.splice(i, 1);
    this.checkItemCount();
  }

  public addSerialListManual(i) {
    this.clearDuplicateWarning();
    console.log("this is item list"+this.item_list[i]['data'])
    if (this.serialNumberInput[i] && this.serialNumberInput[i] != '') {
      this.serialNumberInput[i] = this.serialNumberInput[i].toUpperCase();
      if (this.SerialValidation(this.serialNumberInput[i])) {
        let count = 0;
        for (let s in this.serialNumberList[i]) {
          if (
            this.serialNumberList[i][s].value &&
            this.serialNumberList[i][s].value != ''
          ) {
            if (
              this.serialNumberList[i][s].value == this.serialNumberInput[i]
            ) {
              count++;
            }
          }
        }
        if (count == 0) {
          let rawSerial: any = {};
          rawSerial.id = '';
          rawSerial.value = this.serialNumberInput[i];
          this.serialNumberList[i].push(rawSerial);
        } else {
          this.dialogRef = this.dialog.open(dialogComponent, {
            disableClose: true
          });
          this.dialogRef.componentInstance.msg =
            'Same serial number already exists for this model number. Please enter a different serial number.';
        }
        this.compareSerialQuantityManual(i);
      } else {
        this.dialogRef = this.dialog.open(dialogComponent, {
          disableClose: true
        });
        this.dialogRef.componentInstance.msg =
          'Invalid Serial Number. Please enter valid serial number of length 9 or 10.';
      }
    }
    //input field blank
    this.serialNumberInput = [];
  }

  public deleteSerialListManual(i, s) {
    this.clearDuplicateWarning();
    delete this.serialNumberList[i][s];
    //rearrange index of serial list
    let dummy = [];
    for (let s in this.serialNumberList[i]) {
      if (this.serialNumberList[i][s]) {
        dummy.push(this.serialNumberList[i][s]);
      }
    }
    this.serialNumberList[i] = dummy;
    this.compareSerialQuantityManual(i);
  }

  public checkItemCountManual() {
    let validCount = 0;
    let qtyCount = 0;
    let serialCheck = [];
    let serialCount = 0;
    if (Object.keys(this.item_list).length > 0) {
      for (let i in this.item_list) {
        if (this.manualListValid[i]) {
          validCount++;
        }
        if (parseInt(this.item_list[i].invoicedQuantity) > 0) {
          qtyCount++;
        }
        if (this.compareSerialQuantityManual(i)) {
          serialCheck[i] = true;
        } else {
          serialCheck[i] = false;
        }
      }
    }
    for (let s in serialCheck) {
      if (!serialCheck[s]) {
        serialCount++;
      }
    }
    if (
      validCount == 0 ||
      this.item_list.length == 0 ||
      qtyCount == 0 ||
      serialCount != 0
    ) {
      this.isItem = false;
    } else {
      this.isItem = true;
    }
  }

  public compareSerialQuantityManual(i) {
    //compare serial count and quantity
    if (this.isEdit) {
      let count = 0;
      for (let s in this.serialNumberList[i]) {
        if (this.serialNumberList[i][s].value != '') {
          count++;
        }
      }
      if (count > parseInt(this.item_list[i].invoicedQuantity)) {
        this.showEditSerial[i] = false;
        this.showError(
          'Total count of serial numbers for item cannot be greater than item quantity. Please remove serial number(s) or change your quantity.',
          false
        );
        return false;
      }
      if (count < parseInt(this.item_list[i].invoicedQuantity)) {
        this.showEditSerial[i] = true;
        return true;
      }
      if (count == parseInt(this.item_list[i].invoicedQuantity)) {
        this.showEditSerial[i] = false;
        return true;
      }
    } else {
      if (
        this.serialNumberList[i].length >
        parseInt(this.item_list[i].invoicedQuantity)
      ) {
        this.showEditSerial[i] = false;
        this.showError(
          'Total count of serial numbers for item cannot be greater than item quantity. Please remove serial number(s) or change your quantity.',
          false
        );
        return false;
      }
      if (
        this.serialNumberList[i].length <
        parseInt(this.item_list[i].invoicedQuantity)
      ) {
        this.showEditSerial[i] = true;
        return true;
      }
      if (
        this.serialNumberList[i].length ==
        parseInt(this.item_list[i].invoicedQuantity)
      ) {
        this.showEditSerial[i] = false;
        return true;
      }
    }
  }

  public saveSerialNumberManual(i) {
    this.showField[i] = !this.showField[i];
    this.item_list[i].serialNumber = this.serialNumberList[i];
  }

  public convertItemsArrayManual() {
    let items = [];
    let newItemList = [];
    let final = [];

    if (this.isEdit) {
      let newEntry = false;
      for (let i in this.item_list) {
        if (this.item_list[i].id != '') {
          this.item_list[i].serialNumber = this.serialNumberList[i];
          items[i] = [];
          if (this.item_list[i].serialNumber.length > 0) {
            for (let s in this.item_list[i].serialNumber) {
              items[i].push(this.item_list[i].serialNumber[s]);
            }
          } else if (this.item_list[i].id) {
            let rawSerial = {};
            rawSerial['id'] = this.item_list[i].id;
            rawSerial['value'] = '';
            items[i].push(rawSerial);
          } else {
            let rawSerial = {};
            rawSerial['id'] = '';
            rawSerial['value'] = '';
            items[i].push(rawSerial);
          }
        }
        //check if its a new entry in edit mode
        if (this.item_list[i].id == '') {
          newEntry = true;
        }
      }

      //if New entry is present, then continue as creation
      let count = [];
      let serialCounter = [];
      let loopCount;
      let blankEntry = [];
      for (let i in this.item_list) {
        if (this.item_list[i].id == '') {
          serialCounter[i] = 0;
          this.item_list[i].serialNumber = this.serialNumberList[i];
          count[i] = 0;
          if (this.item_list[i].serialNumber.length > 0) {
            for (let s in this.item_list[i].serialNumber) {
              count[i]++;
            }
          }
        }
      }

      for (let i in this.item_list) {
        if (this.item_list[i].id == '') {
          items[i] = [];
          blankEntry[i] = false;
          if (
            count[i] != 0 &&
            count[i] < parseInt(this.item_list[i].invoicedQuantity)
          ) {
            loopCount = count[i] + 1;
          }
          if (
            count[i] != 0 &&
            count[i] == parseInt(this.item_list[i].invoicedQuantity)
          ) {
            loopCount = count[i];
          }
          if (count[i] == 0) {
            loopCount = 1;
          }
          for (var x = 0; x < loopCount; x++) {
            if (
              count[i] != serialCounter[i] &&
              this.item_list[i].serialNumber.length > 0
            ) {
              for (let s in this.item_list[i].serialNumber) {
                serialCounter[i]++;
                items[i].push(this.item_list[i].serialNumber[s]);
              }
            } else if (!blankEntry[i] && count[i] == serialCounter[i]) {
              blankEntry[i] = true;
              let rawSerial = {};
              rawSerial['id'] = '';
              rawSerial['value'] = '';
              items[i].push(rawSerial);
            }
          }
        }
      }
    } else {
      // Creation mode
      let count = [];
      let serialCounter = [];
      for (let i in this.item_list) {
        serialCounter[i] = 0;
        this.item_list[i].serialNumber = this.serialNumberList[i];
        count[i] = 0;
        if (this.item_list[i].serialNumber.length > 0) {
          for (let s in this.item_list[i].serialNumber) {
            count[i]++;
          }
        }
      }

      let loopCount;
      let blankEntry = [];
      for (let i in this.item_list) {
        items[i] = [];
        blankEntry[i] = false;
        if (
          count[i] != 0 &&
          count[i] < parseInt(this.item_list[i].invoicedQuantity)
        ) {
          loopCount = count[i] + 1;
        }
        if (
          count[i] != 0 &&
          count[i] == parseInt(this.item_list[i].invoicedQuantity)
        ) {
          loopCount = count[i];
        }
        if (count[i] == 0) {
          loopCount = 1;
        }
        for (var x = 0; x < loopCount; x++) {
          if (
            count[i] != serialCounter[i] &&
            this.item_list[i].serialNumber.length > 0
          ) {
            for (let s in this.item_list[i].serialNumber) {
              serialCounter[i]++;
              items[i].push(this.item_list[i].serialNumber[s]);
            }
          } else if (!blankEntry[i] && count[i] == serialCounter[i]) {
            blankEntry[i] = true;
            let rawSerial = {};
            rawSerial['id'] = '';
            rawSerial['value'] = '';
            items[i].push(rawSerial);
          }
        }
      }
    }

    for (let i in items) {
      newItemList[i] = [];
      for (let x in items[i]) {
        newItemList[i].push(Object.assign({}, this.item_list[i]));
      }
    }

    for (let i in newItemList) {
      let count = 0;
      for (let n in newItemList[i]) {
        if (items[i][n].value != null && items[i][n].value != '') {
          count++;
          newItemList[i][n].invoicedQuantity = 1;
          newItemList[i][n].serialNumber = items[i][n].value;
        } else {
          newItemList[i][n].serialNumber = items[i][n].value;
          if (count > 0) {
            newItemList[i][n].invoicedQuantity -= 1;
          }
        }
        newItemList[i][n].id = items[i][n].id;
        final.push(newItemList[i][n]);
      }
    }

    let serialCount = [];
    for (let i in this.item_list) {
      serialCount[this.item_list[i].modelNumber] = {};
      serialCount[this.item_list[i].modelNumber].count = 0;
      serialCount[this.item_list[i].modelNumber].quantity = this.item_list[
        i
      ].invoicedQuantity;
      for (let f in final) {
        if (
          this.item_list[i].modelNumber == final[f].modelNumber &&
          final[f].serialNumber != ''
        ) {
          serialCount[this.item_list[i].modelNumber].count++;
        }
      }
    }

    for (let f in final) {
      for (let s in serialCount) {
        if (final[f].modelNumber == s) {
          if (final[f].serialNumber == '') {
            final[f].invoicedQuantity =
              parseInt(serialCount[s].quantity) -
              parseInt(serialCount[s].count);
          }
        }
      }
    }
    this.finalFormData.returnOrder.items = final;
    return true;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/request-mgmt/confirm/confirm.component.ts